import * as marietta from '../..';
import { MonicaObject } from '.';
import { SVGSprite } from '../flash/display';
import { BUILDING_TYPE_MANSION } from '../Constants';

/** 壁端点の一致判定に使う許容誤差（px） */
const WALL_DOT_MATCH_THRESHOLD: number = 0.001;

/** 壁の平行判定の許容角度差（度） */
const WALL_PARALLEL_ANGLE_TOLERANCE_DEG: number = 0.1;

/** 平角（度） */
const STRAIGHT_ANGLE_DEG: number = 180;

/** 寸法入力による頂点の移動内容 */
type WallMove = {
  /** 移動量 */
  readonly offset: marietta.core.Point;
  /** 入力壁と選択壁の共有頂点（移動前の座標） */
  readonly sharedDot: marietta.core.Point;
};

export default class Room extends MonicaObject {
  _defaultRoomSetting: marietta.webcad.collection.RoomConfigCollection;

  nuriView: SVGElement;

  patternView: SVGElement;

  lockView: SVGElement;

  wallView: SVGElement;

  wallObjList: marietta.webcad.item.parts.Wall[];

  dummyWallView: SVGElement;

  guideView: SVGElement;

  overlayText: marietta.webcad.item.parts.RoomText;

  wallGuideList: marietta.webcad.item.parts.WallGuide[];

  /**
   * コンストラクタ
   */
  // constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
  //   super(_itemInfo);
  // }

  /**
   * リドロー
   */
  reCreateImage = () => {
    let newString: string = '';

    if (this.overlayText.useJyou) {
      const tubo: number = marietta.webcad.util.WebCADUtil.calculateAreaInTsubo(this.itemInfo.dotList);

      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en':
          if (tubo === Math.round(tubo)) {
            newString = `(${String(tubo)}.0jyou)`;
          } else {
            newString = `(${String(tubo)}jyou)`;
          }
          break;
        default:
          if (tubo === Math.round(tubo)) {
            newString = `(${String(tubo)}.0帖)`;
          } else {
            newString = `(${String(tubo)}帖)`;
          }
          break;
      }
    } else {
      newString = `${marietta.webcad.util.WebCADUtil.calculateArea(this.itemInfo.dotList)}㎡`;
    }

    if (this.overlayText.currentString !== newString) {
      // 部屋名の削除
      this.overlayText.deleteMe();
      this.overlayText = null;
    }

    // 削除する
    this.nuriView.remove();
    this.patternView.remove();
    this.wallView.remove();
    this.guideView.remove();
    this.dummyWallView.remove();
    this.createImage();

    // TODO: 畳テクスチャの拡大縮小が難しいので、後で対応
    // 畳ならテクスチャを削除
    if (this.itemInfo.design_type && this.itemInfo.design_type.indexOf('tatami') > -1) {
      this.itemInfo.design_type = null;
    }
  };

  /**
   * マウス移動
   * @private
   */
  protected onMouseMoveHandler(): void {
    // 移動しない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType !== BUILDING_TYPE_MANSION) {
      super.onMouseMoveHandler();
    }
  }

  /**
   * ビューの作成
   */
  createImage() {
    // 部屋の初期設定
    if (!this._defaultRoomSetting) this._defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(this.itemInfo.id);

    // カラーが設定されていなければデフォルトカラーの設定
    if (this.itemInfo.color === undefined || this.itemInfo.color === null || this.itemInfo.color === '') {
      this.itemInfo.color = this._defaultRoomSetting.color;
      this.itemInfo.designColor = this._defaultRoomSetting.designColor;
      this.itemInfo.text = this._defaultRoomSetting.text;
      this.itemInfo.design_type = this._defaultRoomSetting.design_type;
    }

    // 部屋名の削除
    if (this.overlayText) {
      this.overlayText.deleteMe();
      this.overlayText = null;
    }

    // 和室の場合は、都度デザインを取得
    if (this.itemInfo.id.indexOf('rom11') > -1) {
      this.itemInfo.design_type = marietta.webcad.WebCADGlobal.getWashituDesign(this.itemInfo);
    }

    let viewObj: Element;
    if (!this.spt) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    } else {
      viewObj = this.spt.element;
    }
    viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);

    // 塗り
    this.nuriView = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.nuriView.setAttribute('fill', this.itemInfo.color);
    this.nuriView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    this.nuriView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_nuri`);
    viewObj.appendChild(this.nuriView);

    // 模様
    this.patternView = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    if (this.itemInfo.design_type) {
      // 模様がなければライブラリに登録する
      let patternName: string = `${this.itemInfo.design_type}_${this.itemInfo.designColor.replace('#', '0x')}`;
      // 和室の場合は、カラー種類なし
      if (this.itemInfo.id.indexOf('rom11') > -1) patternName = this.itemInfo.design_type;

      const designNode = document.getElementById(`${patternName}`);
      if (!designNode) {
        const patternImage = new Image();
        patternImage.crossOrigin = 'anonymous';
        const pngCode = this.itemInfo.design_type.split('.png')[0];
        patternImage.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/${pngCode}.png`;
        const scope: Room = this;

        patternImage.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = 60;
          canvas.height = 60;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(patternImage, 0, 0, patternImage.width, patternImage.height, 0, 0, 60, 60);
          const imgdata = ctx.getImageData(0, 0, patternImage.width, patternImage.height);
          // HEXの色をRGBに変換
          const patternColor: marietta.webcad.collection.ColorRGB = marietta.webcad.util.ColorUtil.convertToRGB(scope.itemInfo.designColor);
          for (let i = 0; i < imgdata.data.length; i += 4) {
            imgdata.data[i] = patternColor._r;
            imgdata.data[i + 1] = patternColor._g;
            imgdata.data[i + 2] = patternColor._b;
          }
          ctx.putImageData(imgdata, 0, 0);
          const newImage = canvas.toDataURL('image/png');
          const parentNode = document.getElementById('patternContainer').querySelector('defs');
          const patternNode = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
          patternNode.setAttribute('id', patternName);
          patternNode.setAttribute('patternUnits', 'userSpaceOnUse');
          patternNode.setAttribute('width', '60');
          patternNode.setAttribute('height', '60');
          const imageNode = document.createElementNS('http://www.w3.org/2000/svg', 'image');
          imageNode.setAttribute('width', '60');
          imageNode.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', newImage);
          imageNode.setAttribute('x', '0');
          imageNode.setAttribute('y', '0');
          imageNode.setAttribute('width', '60');
          imageNode.setAttribute('height', '60');
          patternNode.appendChild(imageNode);
          parentNode.appendChild(patternNode);
          scope.spt.update();
        };
      }

      this.patternView.setAttribute('style', `fill:url(#${patternName})`);
    } else {
      this.patternView.setAttribute('style', 'fill:none'); // Edgeバグ対応
    }
    this.patternView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    this.patternView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pattern`);
    viewObj.appendChild(this.patternView);

    // 壁
    this.wallObjList = [];
    this.wallGuideList = [];
    this.wallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.wallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGroup`);
    let wall: marietta.webcad.item.parts.Wall;

    this.guideView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.guideView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGuide`);
    let guide: marietta.webcad.item.parts.WallGuide;

    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      // 生成
      wall = new marietta.webcad.item.parts.Wall(i, this.wallView, this.itemInfo.dotList[i], i === this.itemInfo.dotList.length - 1 ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1]);
      // 壁情報がなければ、デフォルトを指定する
      if (this.itemInfo.dotList[i].wall_type === undefined || Number.isNaN(this.itemInfo.dotList[i].wall_type)) {
        this.itemInfo.dotList[i].wall_type = this._defaultRoomSetting.wallType;
      }

      let gpt: marietta.core.Point[] = [];
      if (i === this.itemInfo.dotList.length - 1) {
        gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[i].point, this.itemInfo.dotList[0].point], 40);
      } else {
        gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[i].point, this.itemInfo.dotList[i + 1].point], 40);
      }

      wall.wallType = this.itemInfo.dotList[i].wall_type;
      // wall.wallHeight = this.itemInfo.dotList[i].wall_height;
      wall.parentObj = this;
      wall.parentObjInfo = this.itemInfo;
      this.wallObjList.push(wall);
      guide = new marietta.webcad.item.parts.WallGuide(this.guideView, i);
      guide.parentObj = this;
      if (gpt && gpt.length > 1) {
        guide.firstDot = gpt[0].clone();
        guide.secondDot = gpt[1].clone();
      }
      guide.parentObj = this;
      this.wallGuideList.push(guide);
    }
    viewObj.appendChild(this.wallView);
    viewObj.appendChild(this.guideView);

    // 穴を埋めるダミー壁
    if (this.dummyWallView) this.dummyWallView.remove();
    this.dummyWallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.dummyWallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGroupDummy`);
    let dummyWallObj: SVGElement;
    let maeDot: marietta.webcad.collection.PointCollection;
    let atoDot: marietta.webcad.collection.PointCollection;
    let nextPoint: marietta.core.Point;
    let dot1: marietta.core.Point;
    let dot2: marietta.core.Point;
    let scale: number;
    let points = [];
    let wallColor;
    let hasNaN: boolean;
    for (let i = 0; i < this.itemInfo.dotList.length; i += 1) {
      points = [];
      // 前後の壁
      maeDot = i === 0 ? this.itemInfo.dotList[this.itemInfo.dotList.length - 1] : this.itemInfo.dotList[i - 1];
      atoDot = i === this.itemInfo.dotList.length - 1 ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1];
      wallColor = marietta.webcad.WebCADGlobal.getColorForWallType(this.itemInfo.dotList[i].wall_type);

      // 前後どちらも壁のときだけ角の隙間を埋める
      // 片方が開口だと、開口側へ壁幅の半分だけはみ出して頂点と壁の先端がずれるため
      if (this.itemInfo.dotList[i].wall_type >= 1 && maeDot.wall_type >= 1) {
        // 前の壁
        dot1 = new marietta.core.Point(maeDot.x, maeDot.y);
        dot2 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
        scale = (marietta.core.Point.distance(dot1, dot2) - 5) / marietta.core.Point.distance(dot1, dot2);
        nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
        points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
        points.push(new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y));
        if (scale !== Infinity) {
          dot1 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
          dot2 = new marietta.core.Point(atoDot.x, atoDot.y);
          scale = 5 / marietta.core.Point.distance(dot1, dot2);
          nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
          points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
        }
        if (scale !== Infinity) {
          hasNaN = false;
          for (let k: number = 0; k < points.length; k += 1) {
            if (Number.isNaN(points[k].x) || Number.isNaN(points[k].y)) {
              hasNaN = true;
              break;
            }
          }
          if (!hasNaN) {
            dummyWallObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            dummyWallObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(points));
            dummyWallObj.setAttribute('stroke', wallColor.color);
            dummyWallObj.setAttribute('opacity', wallColor.alpha);
            dummyWallObj.setAttribute('stroke-width', String(marietta.webcad.WebCADGlobal.WALL_WIDTH));
            dummyWallObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy_${i}`);
            this.dummyWallView.appendChild(dummyWallObj);
          }
        }
      }
    }
    viewObj.appendChild(this.dummyWallView);

    if (!this.spt) {
      this.spt = new SVGSprite(viewObj);
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();
    }

    // テキスト
    this.overlayText = new marietta.webcad.item.parts.RoomText(this);
    this.showHideWallGuide(false);
  }

  private cc: number = 0;

  /**
   * 現行のTransform
   */
  getCurrentTransform() {
    let retTransform = '';
    retTransform += `translate( ${this.itemInfo.x}, ${this.itemInfo.y} ) `;
    retTransform += `rotate( ${this.itemInfo.rotation} ) `;
    return retTransform;
  }

  /**
   * デフォルトのデザインを適用する
   */
  setDefaultDesign() {
    // 塗り
    this.nuriView.setAttribute('fill', this.itemInfo.color);
    this.nuriView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    this.nuriView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}_nuri`);

    // 模様
    if (this.itemInfo.design_type) {
      this.patternView.setAttribute('style', `fill:url(#${this.itemInfo.design_type})`);
    } else {
      this.patternView.setAttribute('style', 'fill:none'); // Edgeバグ対応
    }
    this.patternView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    this.patternView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}_pattern`);

    // 部屋名
    this.overlayText.message = this.itemInfo.text;
  }

  /**
   * 子供を移動
   */
  moveChildren = (): void => {
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      // TODO：仮実装、新たな不具合を防ぐため
      // SPタブレット対応甩の応急処置
      // SP&タブレットではMonicaオブジェクトのクリックイベントが走らず
      // こちら this.previousPlace = new marietta.core.Point( this.itemInfo.x, this.itemInfo.y );
      // 上記が走らないため、previousPlaceが更新されず、部屋名がずれる不具合が発生している。
      // 変更点による不具合を回避するため、resetRoomNamePositionで再度位置を計算させる

      const childrenList = [this.overlayText];
      // 子供達を移動して表示
      const idouX: number = this.itemInfo.x - this.previousPlace.x;
      const idouY: number = this.itemInfo.y - this.previousPlace.y;
      for (let i: number = 0; i < childrenList.length; i += 1) {
        if (childrenList[i] instanceof marietta.webcad.item.parts.RoomText) {
          if (childrenList[i].moveTextActive) childrenList[i].setActive(false);
        }
        childrenList[i].move(childrenList[i].x + idouX, childrenList[i].y + idouY);
      }
    } else {
      const childrenList = [this.overlayText];
      // 子供達を移動して表示
      const idouX: number = this.itemInfo.x - this.previousPlace.x;
      const idouY: number = this.itemInfo.y - this.previousPlace.y;
      for (let i: number = 0; i < childrenList.length; i += 1) {
        childrenList[i].move(childrenList[i].x + idouX, childrenList[i].y + idouY);
      }
    }
  };

  updateWallGuide() {
    this.wallGuideList.forEach((wall: marietta.webcad.item.parts.WallGuide) => {
      wall.updateTransforms();
    });
  }

  /**
   * 子供を表示
   */
  showChildren = (): void => {
    const childrenList = [this.overlayText];
    for (let i: number = 0; i < childrenList.length; i += 1) {
      childrenList[i].show();
    }
  };

  /**
   * 子供を隠す
   */
  hideChildren = (): void => {
    const childrenList = [this.overlayText];
    for (let i: number = 0; i < childrenList.length; i += 1) {
      childrenList[i].hide();
    }
  };

  highlight = (status: boolean = true) => {
    if (status) this.nuriView.setAttribute('fill', 'url(#diagonalFill)');
    else this.nuriView.setAttribute('fill', this.itemInfo.color);
  };

  /**
   * 削除
   * */
  deleteMe(deferredObj = null) {
    // 部屋名の削除
    this.overlayText.deleteMe();

    super.deleteMe(deferredObj);
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
  }

  /**
   * 削除
   * */
  removeChildren = () => {
    const childrenList = [this.overlayText];
    for (let i: number = childrenList.length - 1; i >= 0; i -= 1) {
      childrenList[i].deleteMe();
    }
  };

  /**
   * 壁種類のリセット
   * 部屋種類変更時にリセットを行う
   */
  resetAllWallTypes() {
    this._defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(this.itemInfo.id);
    for (let i: number = 0; i < this.wallObjList.length; i += 1) {
      (this.wallObjList[i] as marietta.webcad.item.parts.Wall).wallType = this._defaultRoomSetting.wallType;
    }
  }

  /**
   * マウスにくっつく
   * */
  updateChildren = (): void => {
    if (this.itemInfo.auto_layout) {
      // 部屋名位置のリセット
      this.overlayText.resetRoomNamePosition();
    }
  };

  /**
   * 頂点XMLの取得
   */
  getPointXML(): Element[] {
    const pointNodeList = [];
    let pointNode;
    let localPoint: any;

    for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
      pointNode = document.createElementNS(null, 'point');
      pointNode.setAttribute('index', String(i + 1));

      localPoint = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
      localPoint = this.spt.localToGlobal(localPoint);
      pointNode.setAttribute('x', String(Math.round(localPoint.x / marietta.webcad.WebCADGlobal.scaleSize)));
      pointNode.setAttribute('wall_type', this.itemInfo.dotList[i].wall_type);
      pointNode.setAttribute('y', String(-Math.round(localPoint.y / marietta.webcad.WebCADGlobal.scaleSize - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
      pointNodeList.push(pointNode);
    }
    return pointNodeList;
  }

  /**
   * グリッドに吸い付く
   * */
  snapToGrid = () => {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.itemInfo.x = Math.round(this.itemInfo.x / snapUnit) * snapUnit;
    this.itemInfo.y = Math.round(this.itemInfo.y / snapUnit) * snapUnit;
    this.updateTransforms();

    // カレントの更新
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
  };

  /**
   * 部屋塗り、パターンの変更
   */
  changeRoomPattern(bgColor: string, design: string = '', designColor: string = '') {
    // アイテムインフォコレクションに登録
    this.itemInfo.color = bgColor;
    this.itemInfo.design_type = design;
    this.itemInfo.designColor = designColor;

    // 背景色変更
    this.viewObj.querySelector('path:first-child').setAttribute('fill', this.itemInfo.color);

    // TODO: テクスチャカラバリ実装に合わせてテクスチャ変更処理修正
    // テクスチャ変更
    this.viewObj.querySelectorAll('path:first-child')[1].setAttribute('style', `fill:url(#${this.itemInfo.design_type})`);

    this.reCreateImage();
  }

  /**
   * ロック可視化状態の変更
   */
  changeLockView(value: boolean) {
    super.changeLockView(value);
    if (value) {
      this.overlayText.hide();
    } else {
      this.overlayText.show();
    }
  }

  /**
   * 頂点情報の回転
   */
  rotateDots(value: number): void {
    const r: number = ((value % 360) / 180) * Math.PI;
    let p1: marietta.core.Point;
    let xx: number;
    let yy: number;

    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      p1 = this.itemInfo.dotList[i].point;
      xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
      yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
      this.itemInfo.dotList[i].x = xx;
      this.itemInfo.dotList[i].y = yy;
    }

    this.reCreateImage();
  }

  /**
   * ドットを反転する
   */
  flipDots(): void {
    let i: number;

    // 左上が原点になるように、コンバートしておく
    // Ｘ座標をマイナスにする
    let minX: number;
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x *= -1;
      if (this.itemInfo.dotList[i].x < minX || minX === undefined || minX === null) minX = this.itemInfo.dotList[i].x;
    }

    // 左上原点になるよう修正
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x += 0 - minX;
    }
    this.itemInfo.x -= minX;

    this.reCreateImage();
  }

  /**
   * ドラッグ可能か
   */
  public isCapableOfMove(): boolean {
    if (!super.isCapableOfMove()) return false;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) return false;
    return true;
  }

  /**
   *
   * @param newDistance
   * @param index
   */

  /**
   * 2つの壁が平行かどうか（向きの正逆は問わない）
   */
  private static isWallParallel(wallA: marietta.webcad.item.parts.Wall, wallB: marietta.webcad.item.parts.Wall): boolean {
    const angleA = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(wallA.startDot.point, wallA.endDot.point);
    const angleB = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(wallB.startDot.point, wallB.endDot.point);
    const diff = Math.abs(angleA - angleB) % STRAIGHT_ANGLE_DEG;
    return diff < WALL_PARALLEL_ANGLE_TOLERANCE_DEG || diff > STRAIGHT_ANGLE_DEG - WALL_PARALLEL_ANGLE_TOLERANCE_DEG;
  }

  /**
   * 選択壁を平行移動させる移動量（ベクトル）と、入力壁・選択壁の共有頂点を求める。
   *
   * 入力された辺（inputWall）を指定長にするには、inputWall と選択壁の共有頂点を
   * inputWall のもう一端へ向かって diffDistance 分寄せればよい。この移動量を選択壁の
   * 両端に等しく与えることで、選択壁は向きと長さを保ったまま平行移動する。
   *
   * 移動方向を隣接辺ごとにその辺の向きから決めると、両隣の辺が共有頂点から見て逆向きに
   * 伸びる凹凸形状で選択壁の両端が逆方向に動き、選択壁が斜めになる（STARTS_LIDAR-2086）。
   *
   * @param inputWall 寸法を入力された辺
   * @param selectedWall 選択されている壁（平行移動させる辺）
   * @param diffDistance 入力された辺の現在長 - 入力値（px）
   * @returns 移動内容。両者が頂点を共有しない場合は null
   */
  private static getWallMove(inputWall: marietta.webcad.item.parts.Wall, selectedWall: marietta.webcad.item.parts.Wall, diffDistance: number): WallMove {
    const selectedStart = selectedWall.startDot.point;
    const selectedEnd = selectedWall.endDot.point;
    const inputStart = inputWall.startDot.point;
    const inputEnd = inputWall.endDot.point;

    const isSharedWithSelected = (dot: marietta.core.Point): boolean => marietta.core.Point.distance(dot, selectedStart) < WALL_DOT_MATCH_THRESHOLD
      || marietta.core.Point.distance(dot, selectedEnd) < WALL_DOT_MATCH_THRESHOLD;

    let sharedDot: marietta.core.Point;
    let otherDot: marietta.core.Point;
    if (isSharedWithSelected(inputStart)) {
      sharedDot = inputStart;
      otherDot = inputEnd;
    } else if (isSharedWithSelected(inputEnd)) {
      sharedDot = inputEnd;
      otherDot = inputStart;
    } else {
      return null;
    }

    const movedDot = marietta.webcad.util.WebCADUtil.findPointAlongLine(sharedDot, otherDot, diffDistance);
    return { offset: new marietta.core.Point(movedDot.x - sharedDot.x, movedDot.y - sharedDot.y), sharedDot };
  }

  /**
   * 指定座標と一致する頂点をすべて移動量分ずらす。
   * 他部屋と共有している頂点も同じだけ動かして、部屋間の境界を保つ。
   */
  private static moveSharedDots(room: Room, targetDots: marietta.core.Point[], offset: marietta.core.Point): void {
    for (let i: number = 0; i < room.itemInfo.dotList.length; i += 1) {
      const dot = room.itemInfo.dotList[i];
      const isTarget = targetDots.some((t: marietta.core.Point) => marietta.core.Point.distance(dot.point, t) < WALL_DOT_MATCH_THRESHOLD);
      if (isTarget) {
        dot.x += offset.x;
        dot.y += offset.y;
      }
    }
  }

  public updateItemWithInput(newDistance: number, index: number): void {
    if (this.itemInfo.lock) return;
    const wall = marietta.webcad.control.parts.RoomMovePickerWall.wall as marietta.webcad.item.parts.Wall;
    const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(newDistance);
    const { rooms } = marietta.webcad.control.parts.RoomMovePickerWall;

    const obj = this.wallObjList.find((w: marietta.webcad.item.parts.Wall) => w.index === index);
    const wallDistance = marietta.core.Point.distance(obj.startDot.point, obj.endDot.point);
    const diffDistance = wallDistance - distInPix;

    // 基準壁（選択された辺）は必ず自部屋の wallObjList から特定する。
    // マンションモードでは RoomMovePickerWall.wall（static）が他部屋側の境界壁になることがあり、
    // 部屋間で境界の分割形状が異なると端点一致では見つからないため、
    // その場合はクリック位置の壁リスト（closestWall）から自部屋の壁を引き直す。
    let obj2: marietta.webcad.item.parts.Wall;
    if (wall != null) {
      obj2 = this.wallObjList.find((w: marietta.webcad.item.parts.Wall) => (marietta.core.Point.distance(w.startDot.point, wall.startDot.point) < WALL_DOT_MATCH_THRESHOLD && marietta.core.Point.distance(w.endDot.point, wall.endDot.point) < WALL_DOT_MATCH_THRESHOLD) || (marietta.core.Point.distance(w.startDot.point, wall.endDot.point) < WALL_DOT_MATCH_THRESHOLD && marietta.core.Point.distance(w.endDot.point, wall.startDot.point) < WALL_DOT_MATCH_THRESHOLD));
    }
    if (obj2 == null) {
      const closestWallList = marietta.webcad.control.parts.RoomMovePickerWall.closestWall;
      const ownWallInfo = closestWallList != null ? closestWallList.find((c: any) => c.wall != null && c.wall.parentObj === this) : undefined;
      if (ownWallInfo != null) {
        obj2 = this.wallObjList.find((w: marietta.webcad.item.parts.Wall) => w.index === ownWallInfo.wall.index);
      }
    }
    if (obj2 == null) return;
    const startDot = obj2.startDot.point;
    const endDot = obj2.endDot.point;

    // 移動量は入力された辺から一度だけ決める。隣接辺ごとにその向きで決めると
    // 凹凸形状で選択壁の両端が逆方向に動く（STARTS_LIDAR-2086）。
    const move = Room.getWallMove(obj, obj2, diffDistance);
    if (move == null) return;

    // 入力壁が選択壁と平行（同一直線上に分割された辺への入力）なら共有頂点だけを動かして長さを変える。
    // それ以外は選択壁の両端を動かす。動かす頂点を隣接壁の向きで選ぶと片端しか動かず斜めになる。
    const targetDots: marietta.core.Point[] = Room.isWallParallel(obj, obj2) ? [move.sharedDot] : [startDot, endDot];

    Room.moveSharedDots(this, targetDots, move.offset);
    for (let k: number = 0; k < rooms.length; k += 1) {
      if (this.itemInfo.index !== rooms[k].itemInfo.index) {
        Room.moveSharedDots(rooms[k], targetDots, move.offset);
      }
    }
    this.reCreateImage();
    for (let k: number = 0; k < rooms.length; k += 1) {
      if (this.itemInfo.index !== rooms[k].itemInfo.index) {
        rooms[k].reCreateImage();
      }
    }
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;
    }
    marietta.webcad.WebCADGlobal.updateMeasureLine(false);
    marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  showHideWallGuide(value: boolean) {
    if (value) this.guideView.style.display = 'block';
    else this.guideView.style.display = 'none';
  }

  /**
   * ドットの変換（全体XYを0にする）
   */
  convertDots(): void {
    // XY座標をドットに反映する
    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x += this.itemInfo.x;
      this.itemInfo.dotList[i].y += this.itemInfo.y;
    }
    this.itemInfo.x = 0;
    this.itemInfo.y = 0;
    this.updateTransforms();
    // 描画しなおす
    this.reCreateImage();
  }

  public getAdjacentList = (index:number) => {
    const wallList = this.wallGuideList;
    const adjascent = { wallTextList: [], wall: { wall: null }, rooms: [] };
    adjascent.wall.wall = this.wallObjList[index];
    if (index === 0) {
      adjascent.wallTextList.push(wallList[index + 1]);
      adjascent.wallTextList.push(wallList[wallList.length - 1]);
    } else if (index === wallList.length - 1) {
      adjascent.wallTextList.push(wallList[index - 1]);
      adjascent.wallTextList.push(wallList[0]);
    } else {
      adjascent.wallTextList.push(wallList[index - 1]);
      adjascent.wallTextList.push(wallList[index + 1]);
    }
    return adjascent;
  };
}
